import React from 'react';
import css from './HelpResources.scss';
import Icon from 'SF/MaterialIcon';
import { getWord } from 'utils/tenant';

/**
 * @returns {JSX.Element} a link to Starfish help documentation
 */
function StarfishHelpLink() {
    return (
        <div className={css['helpdesk-item']}>
            <div className={css['helpdesk-icon']}>
                <Icon icon="live_help" aria-hidden="true" />
            </div>
            <div className={css['helpdesk-element']}>
                <a href="../support/help.html" target="_blank">
                    {getWord('Starfish', false) + " Help Center"}
                </a>
            </div>
        </div>
    )
}

export default StarfishHelpLink;
